const Modal = ({ children,onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto relative p-6">

      <button
        className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
        onClick={onClose}
      >
        ✕ 
      </button>

      {children}
    </div>
  </div>
);
export default Modal